import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../graphql/types.generated';
export type OrganisationsQueryVariables = GraphQLTypes.Exact<{
  accountUuid: GraphQLTypes.Scalars['String']['input'];
  nameContains?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type OrganisationsQueryResult = { __typename?: 'Query' } & {
  network?: GraphQLTypes.Maybe<
    { __typename?: 'Network' } & {
      organisations?: GraphQLTypes.Maybe<
        { __typename?: 'NetworksOrganisationInterfaceConnection' } & {
          nodes?: GraphQLTypes.Maybe<
            Array<
              GraphQLTypes.Maybe<
                | ({ __typename?: 'AgentOrganisation' } & Pick<
                    GraphQLTypes.AgentOrganisation,
                    'assignedRoles' | 'id' | 'name' | 'type'
                  >)
                | ({ __typename?: 'ForwarderOrganisation' } & Pick<
                    GraphQLTypes.ForwarderOrganisation,
                    'assignedRoles' | 'id' | 'name' | 'type'
                  >)
                | ({ __typename?: 'MyOrganisation' } & Pick<
                    GraphQLTypes.MyOrganisation,
                    'assignedRoles' | 'id' | 'name' | 'type'
                  >)
                | ({ __typename?: 'SavedOrganisation' } & Pick<
                    GraphQLTypes.SavedOrganisation,
                    'assignedRoles' | 'id' | 'name' | 'type'
                  >)
              >
            >
          >;
          pageInfo: { __typename: 'PageInfo' } & Pick<
            GraphQLTypes.PageInfo,
            'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
          >;
        }
      >;
    }
  >;
};

export const OrganisationsQueryDocument = gql`
  query organisationsQuery(
    $accountUuid: String!
    $nameContains: String
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    network(id: $accountUuid) {
      organisations(nameContains: $nameContains, first: $first, last: $last, before: $before, after: $after) {
        nodes {
          assignedRoles
          id
          name
          type
        }
        pageInfo {
          ...PageInfo
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;
